import { getJSON } from 'common/util/request'

export const getCommittees = () => getJSON(`committees`, { shouldNormalize: false })

export const getCommitteeForWhichUserHasAction = () =>
    getJSON(`action_items/committees`, { shouldNormalize: false })
